import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import Box from '@mui/material/Box';
import { Button, Divider } from '@mui/material';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import MuiAlert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import useCourses from './Courses.services';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from "react-dnd-html5-backend";
import SyllabusEditor from './SyllabusEditor';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CourseDetail = () => {

  const { id } = useParams();
  const [openDialog, setOpenDialog] = useState(false);
  const [openSubItemDialog, setOpenSubItemDialog] = useState(false);
  const [cardEditing, setCardEditing] = useState({ id: -1, name: "" });
  const [cardSubItemEditing, setCardSubItemEditing] = useState({ parentId: -1, id: -1, name: "" });

  const {
    courseDetail,
    getCourse,
    updateName,
    updateSPTR,
    updateSuccess,
    updateFailure,
    updateCourse,
    originalDataChanged,
    handleClose,
    addSyllabusElement,
    removeSyllabusElement,
    updateSyllabus,
    onEditSubitemName,
    onRemoveSubitem,
    onAddSubitem,
  } = useCourses(2);

  useEffect(() => {
    getCourse(id);
  }, []);

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <Toolbar />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
          {/* Recent Orders */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" gutterBottom>
                Datos generales
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography>ID: {courseDetail.id}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="name"
                    name="name"
                    label="Nombre del curso"
                    fullWidth
                    autoComplete="given-name"
                    variant="standard"
                    value={courseDetail.name}
                    onChange={(event) => {
                      updateName(event.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="sptr"
                    name="sptr"
                    label="SPTR (opcional)"
                    fullWidth
                    autoComplete="given-name"
                    variant="standard"
                    value={courseDetail.sptr ?? ''}
                    onChange={(event) => {
                      updateSPTR(event.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <DndProvider backend={HTML5Backend}>
                    <SyllabusEditor
                      syllabus={courseDetail.syllabus ?? []}
                      addSyllabusElement={addSyllabusElement}
                      removeSyllabusElement={removeSyllabusElement}
                      updateSyllabus={updateSyllabus}
                      onEditItem={(card) => {
                        setCardEditing(card)
                        setOpenDialog(true);
                      }}
                      onEditSubitem={(itemId, subItem) => {
                        // onEditSubitemName
                        onEditSubitemName(subItem);
                        setCardSubItemEditing({ parentId: itemId, ...subItem });
                        setOpenSubItemDialog(true);
                      }}
                      onRemoveSubitem={onRemoveSubitem}
                      onAddSubitem={onAddSubitem}
                    />
                  </DndProvider>
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Divider />
                  <Button
                    disabled={!originalDataChanged}
                    variant="contained"
                    sx={{ mt: 3, ml: 1 }}
                    onClick={() => { updateCourse() }}
                  >
                    Actualizar
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Editar</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ahora puedes modificar el elemento que has seleccionado.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Tema"
            type="email"
            fullWidth
            variant="standard"
            value={cardEditing.name}
            onChange={(event) => {
              setCardEditing({
                ...cardEditing,
                name: event.target.value,
              });
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancelar</Button>
          <Button onClick={() => {
            let newSyllabus = courseDetail.syllabus?.map((element) => {
              return element.id == cardEditing.id ? cardEditing : element;
            });
            updateSyllabus(newSyllabus)
            setOpenDialog(false);
          }}>Aceptar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openSubItemDialog} onClose={() => setOpenSubItemDialog(false)}>
        <DialogTitle>Editar</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ahora puedes modificar el elemento que has seleccionado.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Subtema"
            placeholder='Nuevo subtema'
            type="email"
            fullWidth
            variant="standard"
            value={cardSubItemEditing.name}
            onChange={(event) => {
              setCardSubItemEditing({
                ...cardSubItemEditing,
                name: event.target.value,
              });
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSubItemDialog(false)}>Cancelar</Button>
          <Button onClick={() => {
            let tempSyllabus = JSON.parse(JSON.stringify(courseDetail.syllabus));
            /// modify on temporal the subitem edited by form
            const processSubItems = (parent) => {
              const newList = parent.subItem.map((subitem) => {
                return subitem.id != cardSubItemEditing.id
                  ? subitem
                  : cardSubItemEditing;
              });
              parent.subItem = newList;
              return parent;
            }

            let newSyllabus = tempSyllabus?.map((parentElement) => {
              return parentElement.id != cardSubItemEditing.parentId
                ? parentElement
                : processSubItems(parentElement);
            });

            updateSyllabus(newSyllabus)
            setOpenSubItemDialog(false);
          }}>Aceptar</Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={updateSuccess} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          Curso actualizado
        </Alert>
      </Snackbar>
      <Snackbar open={updateFailure} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          Error, no se pudo actualizar los datos del curso
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CourseDetail;
